import { makeStyles, Text } from '@fluentui/react-components';
import { useAutofocus } from '@utils';
import { FreddyThumbsUp } from '@utils-global';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'linear-gradient(to bottom right, #091731, #1D305A)',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
  },
  image: {
    width: '55%',
    marginBottom: '16px',
  },
  title: {
    color: '#ffffff',
    textAlign: 'center',
  },
  description: {
    color: '#E0E0E0',
    textAlign: 'center',
    marginTop: '8px',
    padding: '0 24px',
    whiteSpace: 'pre-line',
  },
  footer: {
    color: '#E0E0E0',
    textAlign: 'center',
    position: 'absolute',
    bottom: '32px',
  },
});

type SpamReportResultProps = {
  title?: string;
  description?: string;
  image?: string;
  footer?: string;
};

export const SpamReportResult = ({ title, description, image, footer }: SpamReportResultProps) => {
  const styles = useStyles();
  const { targetRef } = useAutofocus();
  const { t } = useTranslation();

  return (
    <section
      tabIndex={-1}
      ref={targetRef}
      className={styles.wrapper}
      aria-label="Report result page"
    >
      <img
        src={image ?? FreddyThumbsUp}
        alt=""
        className={styles.image}
        aria-hidden="true"
      />
      <Text weight="semibold" size={600} className={styles.title} role="heading">
        {title ?? t('reportPage.spam.title')}
      </Text>
      <Text weight="regular" size={300} className={styles.description}>
        {description ?? t('reportPage.spam.description')}
      </Text>
      <Text weight="regular" size={200} className={styles.footer}>
        {footer ?? t('reportPage.spam.footer')}
      </Text>
    </section>
  );
};
